var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.995 2.248a7.49 7.49 0 0 1 7.496 7.249l.004.25v4.098L20.875 17a1.251 1.251 0 0 1-1.145 1.751l-4.735.002A3 3 0 0 1 9 18.929l-.005-.178H4.27a1.25 1.25 0 0 1-1.146-1.748l1.371-3.158V9.747c.001-4.154 3.352-7.5 7.5-7.5Zm1.5 16.503-3 .002a1.5 1.5 0 0 0 2.994.144l.006-.146Zm-1.5-15.003c-3.32 0-6 2.674-6 6v4.41L4.651 17.25h14.697l-1.353-3.093V9.76l-.003-.225a5.988 5.988 0 0 0-5.997-5.787Z",
    fill: "#666"
  })));
};
export default SvgNotification;